import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { LiveBadge } from "@/components/common/LiveBadge";
import { STREAM_STATUS, STREAM_PLATFORMS } from "@/config/site";

export const LiveNowSection = () => {
  const { isLive, upcoming } = STREAM_STATUS;

  return (
    <section data-testid="live-now-section" className="border-y border-border-dark bg-surface-dark py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <Reveal>
          <div className="flex flex-col gap-10 border border-border-dark bg-brand-black p-8 md:flex-row md:items-center md:justify-between md:p-12">
            <div>
              <LiveBadge isLive={isLive} />
              <h2 className="mt-4 font-heading text-4xl uppercase text-white sm:text-5xl">{isLive ? "Live Now" : "Nothing Live Right Now"}</h2>
              <p className="mt-3 max-w-md text-white/60">{isLive ? "Match information goes here" : upcoming}</p>
            </div>
            <div className="flex flex-wrap items-center gap-4">
              <div className="flex flex-wrap gap-2">
                {STREAM_PLATFORMS.map((p) => (
                  <span key={p.id} data-testid={`live-now-platform-${p.id}`} className="border border-border-dark px-3 py-1.5 font-subheading text-xs uppercase tracking-wide text-white/50">
                    {p.name}
                  </span>
                ))}
              </div>
              <Link
                to="/live"
                data-testid="live-now-view-btn"
                className="inline-flex items-center gap-2 bg-brand-purple px-6 py-3 font-subheading text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-brand-purple-hover"
              >
                Go To Live Page <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
